var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-sm-6"},[_c('h1',{staticClass:"m-0 text-dark"},[_vm._v(_vm._s(_vm.page))])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }